// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "4dd7979/js/" + chunkId + ".js";
};